import {
    useEffect,
} from 'react'
import {
    useState,
} from 'react'

import {
    InputGroup,
    InputRightAddon,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
    Stack,
} from '@chakra-ui/react'

export default function LengthSubform({ setLength, prefilledLength }) {

    const [mins, setMins] = useState(0)
    const [hours, setHours] = useState(0)

    useEffect(() => {
        const calculatedLength = (parseInt(hours * 60) + parseInt(mins))

        setLength(calculatedLength)
    }, [hours, mins])

    useEffect(() => {
        if (!prefilledLength)
            return
        
        setMins(prefilledLength % 60)
        setHours(Math.floor(prefilledLength / 60))
        
    }, [prefilledLength])

    return (
        <>
            <Stack
                direction='row'
                spacing={4}
                align='center'
            >
                {/* Hour input */}
                <InputGroup>
                    <NumberInput
                        onChange={(valueString) => setHours(parseInt(valueString))}
                        value={hours}
                        min={0}
                        max={999}
                        maxWidth='80px'
                    >
                        <NumberInputField />
                        <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                        </NumberInputStepper>
                    </NumberInput>
                    <InputRightAddon
                        children='hours'
                    />
                </InputGroup>

                {/* Minute input */}
                <InputGroup>
                    <NumberInput
                        onChange={(valueString) => setMins(parseInt(valueString))}
                        value={mins}
                        min={0}
                        max={59}
                        maxWidth='80px'
                    >
                        <NumberInputField />
                        <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                        </NumberInputStepper>
                    </NumberInput>
                    <InputRightAddon
                        children='minutes'
                    />
                </InputGroup>
            </Stack>
        </>
    )
}
